import { useState } from "react";
import { FalloutCharacter } from "../Data/Response";


interface BrawlSequenceViewArgs {
    targets: FalloutCharacter[];
    brawlHandler: (characterId: string) => void;
}

const BrawlSequenceView: React.FC<BrawlSequenceViewArgs> = args => {
    var [target, setTarget] = useState<string | null>(null);

    if (!target) {
        return <BrawlTargetSelectView
            targets={args.targets}
            setTarget={t => setTarget(t)}
        />
    }

    return <div>
        <h1>Confirm Brawl</h1>
        <button
            onClick={e => {
                args.brawlHandler(target);
            }}
        >Confirm Brawl!</button>
    </div>
}



interface BrawlTargetSelectViewArgs {
    targets: FalloutCharacter[];
    setTarget: (characterId: string) => void;
    selectedTarget?: string;
}

const BrawlTargetSelectView: React.FC<BrawlTargetSelectViewArgs> = args => {

    return <div>
        <h3>Select Target</h3>
        <ul>
            {args.targets.map(t => {
                return <li>
                    <button
                        onClick={e => {
                            args.setTarget(t.id)
                        }}
                    >{t.name}</button>
                </li>
            })}
        </ul>
    </div>
}

export default BrawlSequenceView;